import { render, staticRenderFns } from "./SentimentCyclicalityVIP.vue?vue&type=template&id=72c690de&scoped=true"
import script from "./SentimentCyclicalityVIP.vue?vue&type=script&lang=js"
export * from "./SentimentCyclicalityVIP.vue?vue&type=script&lang=js"
import style0 from "./SentimentCyclicalityVIP.vue?vue&type=style&index=0&id=72c690de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c690de",
  null
  
)

export default component.exports